import { StaticLabel } from "./StaticLabel.js";
import { TextureLoader } from "three";

class FigureImageLabel extends StaticLabel {
  constructor(options) {
    super();
    this.type = "STATIC_IMAGE_LABEL";
    this.name = options.name || "Default Static Image Name";
    let imageURL = "https://mapability-website.s3.amazonaws.com/textures/inventum_logo_placeholder.png";

    this.childTextLabels = options.childTextLabels || [];
    this.defaultTextPosition = options.defaultTextPosition || "below";

    if (options !== undefined && options.imageURL !== undefined) {
      imageURL = options.imageURL;
    }

    if (options !== undefined && options.scale !== undefined) {
      this.setSize(Number(options.scale));
    }

    if (options !== undefined && options.position !== undefined) {
      this.setPosition(options.position.x, options.position.y);
    }

    this.imageURL = imageURL;
    this.imageVisible = options.imageVisible !== false;
    this.labelVisible = false;

    // Tag the sprite so the thumbnail generator can identify image labels
    // whose textures may still be loading (map will be null until onLoad).
    this.sprite.userData.isImageLabel = true;

    this.loadImage(this.imageURL);

    if (options !== undefined && options.visibleStart !== undefined) {
      this.visibleStart = options.visibleStart;
      if (this.visibleStart) {
        this.setVisible(true);
      }
    }
  }

  loadImage(url) {
    if (!url) {
      this.clearImage();
      return;
    }

    this.imageURL = url;
    new TextureLoader().load(url, this.setImage.bind(this));
  }

  setImage(texture) {
    super.setImage(texture);
    this.sprite.material.opacity = 1;
    this.sprite.material.transparent = true;
    this.sprite.material.depthWrite = false;
    this.sprite.visible = this.hasImage() && this.imageVisible !== false && this.labelVisible;
  }

  hasImage() {
    return Boolean(this.imageURL);
  }

  clearImage() {
    this.imageURL = "";
    this.imageVisible = true;
    if (this.sprite.material.map && typeof this.sprite.material.map.dispose === "function") {
      this.sprite.material.map.dispose();
    }
    this.sprite.material.map = null;
    this.sprite.material.needsUpdate = true;
    this.sprite.visible = false;
  }

  setVisible(visibleState) {
    this.labelVisible = visibleState;
    super.setVisible(this.hasImage() && this.imageVisible !== false && this.labelVisible);
  }

  setImageVisible(visibleState) {
    this.imageVisible = visibleState !== false;
    this.sprite.visible = this.hasImage() && this.imageVisible && this.labelVisible;
  }

  toggleImageVisible() {
    this.setImageVisible(this.imageVisible === false);
  }

  isVisible() {
    return this.labelVisible ?? this.sprite.visible;
  }

  addChildTextLabel(textLabelId) {
    if (!this.childTextLabels.includes(textLabelId)) {
      this.childTextLabels.push(textLabelId);
    }
  }

  removeChildTextLabel(textLabelId) {
    const index = this.childTextLabels.indexOf(textLabelId);
    if (index > -1) {
      this.childTextLabels.splice(index, 1);
    }
  }

  serialize() {
    return {
      type: "STATIC_IMAGE_LABEL",
      name: this.name,
      id: this.id,
      imageURL: this.imageURL,
      imageVisible: this.imageVisible !== false,
      position: { x: this.screenPosition.x, y: this.screenPosition.y },
      scale: this.scaleFactor,
      childTextLabels: this.childTextLabels,
      defaultTextPosition: this.defaultTextPosition,
      visibleStart: this.visibleStart,
    };
  }
}

export { FigureImageLabel };
